import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=caefa1d0"
import script from "./AssignmentDetails.vue?vue&type=script&lang=js"
export * from "./AssignmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports